import React from "react";

const ContactIcon = ({ size = 20, className = "", strokeWidth = 2 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 6h18v12H3z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round"/>
    <path d="M3 7l9 6 9-6" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default ContactIcon;
